import secureLocalStorage from "react-secure-storage";
import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { GridCell } from "@progress/kendo-react-grid";
import { formatNumber } from "@telerik/kendo-intl";
export default class ImpactEditComponent extends GridCell {
  handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: Math.trunc(e.value)
      });
  
  };
  handleEditCell = () => {
      if (this.props.dataItem.riskRegisterId && !this.props.field.endsWith("_Post")&& !this.props.field.endsWith("_Current")){
        this.props.onEditCell(
          this.props.dataItem,
          this.props.field,
          this.props.stateData
        );
      }

  };
  

  componentDidUpdate=()=>{
    if(this.props.dataItem.inEdit&&document.getElementById(this.props.field)){
      document.getElementById(this.props.field).focus();
    }
  }
  
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;

    const value = this.props.dataItem[this.props.field];
    const impact =
      this.props.dataItem.impactResponse &&
      this.props.dataItem.impactResponse.find(
        (item) => item.name + "_" + item.type == this.props.field
      );
    let access = false;
    if (impact) {
      access = true;
    }

    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <NumericTextBox
            value={value}
            onChange={this.handleChange}
            id={this.props.field}
            
          />
        </td>
      );
    }
    if (
      this.props.dataItem.inEdit !== this.props.field ||
      this.props.dataItem.inEdit === true
    ) {
      if (loginUserId === ownerId && access) {
        return (
          <td onClick={this.handleEditCell}>
            <span>
              {this.props.field.endsWith("_Post") ? (
                <span className="yellowCell" title="Approved Value">
                  &nbsp;{" "}
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              ) : this.props.field.endsWith("_Current") ? (
                <span className="turquoiseBlue">
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              ) : (
                <span>
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              )}
            </span>
          </td>
        );
      } else {
        return this.props.dataItem.role === "Standard User" ||
          this.props.dataItem.role === "View Only" ||
          !access ? (
          <td>
            <span>
              {this.props.field.endsWith("_Post") ? (
                <span className="yellowCell" title="Approved Value">
                  &nbsp;{" "}
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              ) : this.props.field.endsWith("_Current") ? (
                <span className="turquoiseBlue">
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              ) : (
                <span>
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              )}
            </span>
          </td>
        ) : (
          <td onClick={this.handleEditCell}>
            <span>
              {this.props.field.endsWith("_Post") ? (
                <span className="yellowCell" title="Approved Value">
                  &nbsp;{" "}
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              ) : this.props.field.endsWith("_Current") ? (
                <span className="turquoiseBlue">
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              ) : (
                <span>
                  {value || value === 0
                    ? formatNumber(parseInt(value), "##,#")
                    : ""}
                </span>
              )}
            </span>
          </td>
        );
      }
    }
  }
}
